module.exports = __webpack_public_path__ + "img/electricity.7e7662a6.jpg";